import React, { useState, useEffect } from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useMember } from '../contexts/MemberContext';
import { ReactComponent as CinchLogo } from '../cinch.svg';
import CompanyLogo from '../components/CompanyLogo';
import useDeviceEvents from '../hooks/useDeviceEvents';

/**
 * Landing page is the main interface for authenticated devices
 * Shows welcome screen for the loyalty program
 */
const LandingPage = () => {
  const { deviceInfo, primaryColor, secondaryColor } = useAuth();
  const { clearMember } = useMember();
  const navigate = useNavigate();
  const [blinkTextColor, setBlinkTextColor] = useState('#1976d2'); // Start with primary color

  // Clear member data when landing page loads
  useEffect(() => {
    clearMember();
  }, [clearMember]);

  // Flashing text effect
  useEffect(() => {
    const interval = setInterval(() => {
      setBlinkTextColor(prevColor => prevColor === primaryColor ? secondaryColor : primaryColor);
    }, 800); // Toggle color every 800ms

    return () => clearInterval(interval);
  }, [primaryColor, secondaryColor]);

  // Navigate to phone entry page when screen is touched/clicked
  const handleScreenTouch = () => {
    navigate('/phone-entry');
  };

  const eventHandlers = useDeviceEvents(handleScreenTouch);

  return (
    <Container
      maxWidth="lg"
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        py: 4,
        cursor: 'pointer' // Change cursor to indicate clickable
      }}
      {...eventHandlers}
    >
      {/* Main content area */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        flexGrow={1}
      >

        <Box display="flex" justifyContent="center" mt={2} mb={4}>
          <CompanyLogo height={200} />
        </Box>

        {/* Welcome header */}
        <Typography variant="h4" component="h1" align="center" gutterBottom fontWeight="bold" color="primary.main">
          Welcome to {deviceInfo?.location_name || deviceInfo?.company_name || 'our location'}.
        </Typography>
        <Typography variant="h4" component="h1" align="center" gutterBottom fontWeight="bold" color="primary.main">
          Join our rewards program!
        </Typography>

        <Box mt={4}>
          {/* Instructions */}
          <Typography variant="h5" align="center" gutterBottom>
            Enter your mobile number to start earning rewards
          </Typography>

          {/* Flashing text */}
          <Typography
            variant="h4"
            align="center"
            sx={{ color: blinkTextColor, transition: 'color 0.4s ease', mt: 6 }}
            fontWeight="bold"
          >
            Touch Screen to Begin
          </Typography>
        </Box>
      </Box>

      {/* Footer */}
      <Box pb={2} display="flex" justifyContent="center" alignItems="center">
        <Typography variant="body3">
          powered by
        </Typography>
        <Box ml={1} display="flex" alignItems="center">
          <CinchLogo
            width={75}
            style={{ marginRight: '4px' }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default LandingPage;